
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auxilio-emergencial-fgts",
      function () {
        return require("private-next-pages/auxilio-emergencial-fgts/index.js");
      }
    ]);
  